import { createSelector } from 'redux-orm';
import orm from '%paysera_seat_selection/js/seatSelection/redux/model';
import dbSelector from './dbSelector';
import selectHall from './selectHall';

const selectHallCacheKey = createSelector(
    orm,
    dbSelector,
    state => selectHall(state),
    (session, hall) => {
        if (hall === null) {
            return null;
        }

        return hall.cacheKey;
    },
);

export default selectHallCacheKey;
